var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { UXPContext } from "@core/context/Context";
import ToastContext from "./ToastContext";
import Toast from "./Toast";
import PortalContainer from "../../widget/popups/PortalContainer";
// create a random id
function generateId() {
    const date = new Date();
    const random = Math.round(Math.random() * 10000);
    return date.getTime().toString() + random.toString();
}
// Default values for ToastProvider (excluding children)
const defaultToastProviderProps = {
    position: "bottom-right",
    autoClose: true,
    showCloseBtn: true,
    closeAfter: 5000,
};
// ToastProvider component
const ToastProvider = (props) => {
    // Merge default props with provided props
    const mergedProps = Object.assign(Object.assign({}, defaultToastProviderProps), props);
    const context = React.useContext(UXPContext);
    const [toasts, setToasts] = React.useState([]);
    const toastRef = React.useRef([]);
    // add method
    const add = (content) => {
        const id = generateId();
        const createdAt = new Date().getTime();
        // Merge default ToastProvider props (except position) into content
        const { position } = mergedProps, rest = __rest(mergedProps, ["position"]);
        const updatedContent = Object.assign(Object.assign({}, rest), content);
        const newToast = { id, content: updatedContent, createdAt };
        const _toasts = [...(toastRef.current || []), newToast];
        toastRef.current = _toasts;
        setToasts(_toasts);
    };
    // remove method 
    const remove = React.useCallback((id) => {
        const _toasts = toastRef.current.filter((toast) => toast.id !== id);
        toastRef.current = _toasts;
        setToasts(_toasts);
    }, []);
    // Helper to update content with type
    const updatedContent = (content, type) => {
        const defaults = { type };
        if (typeof content === "string") {
            content = { content };
        }
        return Object.assign(Object.assign({}, defaults), content);
    };
    // Toast type methods
    const success = (content) => add(updatedContent(content, "success"));
    const error = (content) => add(updatedContent(content, "error"));
    const warning = (content) => add(updatedContent(content, "warning"));
    const info = (content) => add(updatedContent(content, "info"));
    const custom = (content) => add(updatedContent(content, "custom"));
    // Provider value
    const providerValue = React.useMemo(() => ({ success, error, warning, info, custom, remove }), [remove]);
    // Render a single toast
    const renderToast = (toast) => (_jsx(Toast, { icon: toast.content.icon, type: toast.content.type, title: toast.content.title, content: toast.content.content, onClose: toast.content.onClose || null, showCloseBtn: toast.content.showCloseBtn, autoClose: toast.content.autoClose, instance: toast.id, closeAfter: toast.content.closeAfter, createdAt: toast.createdAt }, toast.id));
    // Calculate container position; adjust for RTL if needed
    const containerPosition = (context === null || context === void 0 ? void 0 : context.direction) === "rtl"
        ? mergedProps.position
            .replace("right", "temp")
            .replace("left", "right")
            .replace("temp", "left")
        : mergedProps.position;
    return (_jsxs(ToastContext.Provider, { value: providerValue, children: [_jsx(PortalContainer, { disableScroll: false, children: _jsx("div", { className: `uxpcore_toast__container ${containerPosition}`, style: { padding: toasts.length > 0 ? "15px" : "0" }, children: toasts.map(renderToast) }) }), props.children] }));
};
export default ToastProvider;
